import GuestAddressingIcon from 'assets/images/invitations/guest-addressing.svg';
import { CardSettings, CARD_TYPES, LeadCardType } from './CardTypes';
import { LABEL_BY_CARD_TYPE } from './labelByCardType';
import { URL_SLUG_BY_CARD_TYPE } from './urlSlugByCardType';

export const SETTINGS_BY_CARD_TYPE: Record<LeadCardType, CardSettings> = {
  MATCHING_SUITES: {
    type: 'MATCHING_SUITES',
    urlSlug: URL_SLUG_BY_CARD_TYPE.MATCHING_SUITES,
    label: LABEL_BY_CARD_TYPE.MATCHING_SUITES,
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: false,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.invitation]: {
    type: CARD_TYPES.invitation,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.invitation],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.invitation],
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasShapes: true,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: true,
    isLead: true,
    showPdpFreeAddressingModule: false,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: true,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: true,
  },
  [CARD_TYPES.std]: {
    type: CARD_TYPES.std,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.std],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.std],
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasShapes: true,
    hasMagnet: true,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: true,
    isLead: true,
    showPdpFreeAddressingModule: false,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: true,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: true,
  },
  // TODO DSTD
  [CARD_TYPES.dstd]: {
    type: CARD_TYPES.dstd,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.dstd],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.dstd],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: true,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: true,
    isLead: true,
    showPdpFreeAddressingModule: false,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: true,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: true,
  },
  [CARD_TYPES.ctd]: {
    type: CARD_TYPES.ctd,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.ctd],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.ctd],
    hasFoil: false,
    hasLetterpress: true,
    hasMotifs: false,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: false,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: true,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.thankyou]: {
    type: CARD_TYPES.thankyou,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.thankyou],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.thankyou],
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: true,
    freeAddressingText: 'Enjoy FREE Guest Addressing & Envelopes',
    freeAddressingImage: GuestAddressingIcon,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.menu]: {
    type: CARD_TYPES.menu,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.menu],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.menu],
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasShapes: true,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.program]: {
    type: CARD_TYPES.program,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.program],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.program],
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasShapes: true,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.place]: {
    type: CARD_TYPES.place,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.place],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.place],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: true,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: false,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: true,
    freeAddressingText: 'Enjoy FREE printing on Place Cards!',
    freeAddressingImage: GuestAddressingIcon,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  DETAILS: {
    type: 'DETAILS',
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.enclosure],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.enclosure],
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.enclosure]: {
    type: CARD_TYPES.enclosure,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.enclosure],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.enclosure],
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: true,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.rsvp]: {
    type: CARD_TYPES.rsvp,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.rsvp],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.rsvp],
    hasFoil: true,
    hasLetterpress: true,
    hasMotifs: false,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
    isLead: false,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: null,
    showPdpCovidBanner: null,
    showReviewStepCtdBanner: null,
  },
  ENVELOPE: {
    type: 'ENVELOPE',
    urlSlug: URL_SLUG_BY_CARD_TYPE.ENVELOPE,
    label: LABEL_BY_CARD_TYPE.ENVELOPE,
    hasFoil: false, // Not used for now
    hasLetterpress: false,
    hasMotifs: false,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
    isLead: false,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: null,
    showPdpCovidBanner: null,
    showReviewStepCtdBanner: null,
  },
  [CARD_TYPES.holiday]: {
    type: CARD_TYPES.holiday,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.holiday],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.holiday],
    hasFoil: true,
    hasLetterpress: false,
    hasMotifs: true,
    hasShapes: true,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: true,
    hasCustomPhoto: true,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: true,
    freeAddressingText: 'Enjoy FREE Guest Addressing & Envelopes',
    freeAddressingImage: GuestAddressingIcon,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.weddingShower]: {
    type: CARD_TYPES.weddingShower,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.weddingShower],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.weddingShower],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: true,
    hasShapes: true,
    hasMagnet: false,
    hasMultipleOrientations: true,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: true,
    freeAddressingText: 'Enjoy FREE Guest Addressing & Envelopes',
    freeAddressingImage: GuestAddressingIcon,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.tableNumber]: {
    type: CARD_TYPES.tableNumber,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.tableNumber],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.tableNumber],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: true,
    hasShapes: true,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: false,
    isVowRenewal: false,
    isLead: true,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.paperAddOns]: {
    type: CARD_TYPES.paperAddOns,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.paperAddOns],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.paperAddOns],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: false,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
    isLead: false,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.bellyBand]: {
    type: CARD_TYPES.bellyBand,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.bellyBand],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.bellyBand],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: false,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
    isLead: false,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.vellumJacket]: {
    type: CARD_TYPES.vellumJacket,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.vellumJacket],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.vellumJacket],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: false,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
    isLead: false,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
  [CARD_TYPES.waxSeal]: {
    type: CARD_TYPES.waxSeal,
    urlSlug: URL_SLUG_BY_CARD_TYPE[CARD_TYPES.waxSeal],
    label: LABEL_BY_CARD_TYPE[CARD_TYPES.waxSeal],
    hasFoil: false,
    hasLetterpress: false,
    hasMotifs: false,
    hasShapes: false,
    hasMagnet: false,
    hasMultipleOrientations: false,
    hasThirdPartyDesigns: false,
    hasCustomPhoto: false,
    hasNoCustomPhoto: true,
    isVowRenewal: false,
    isLead: false,
    showPdpFreeAddressingModule: null,
    freeAddressingText: null,
    freeAddressingImage: null,
    showPdpCtdBanner: false,
    showPdpCovidBanner: false,
    showReviewStepCtdBanner: false,
  },
} as const;
